import { Box, Paper, Typography } from "@mui/material";
import DomesticMarketMonthlyStockSalesForm from "./DomesticMarketMonthlyStockSalesForm";
import DomesticMarketMonthlyStockSalesChart from "./DomesticMarketMonthlyStockSalesChart";
import Favorites from "../../../components/favorite/Favorites";
import { useDomesticMarketMonthlyStockSalesContext } from "../../../context/domestic-market/monthly-stock-sales/DomesticMarketMonthlyStockSalesContext";
import ShowFavoritesButton from "../../../components/favorite/ShowFavoritesButton";
import { deleteData } from "../../../lib/dashboard/actions";
import { mutate } from "swr";
import DomesticMarketMonthlyStockSalesFavoriteCard from "./DomesticMarketMonthlyStockSalesFavoriteCard";

const DomesticMarketMonthlyStockSales = () => {
  const {
    favorites,
    setSelectedCompany,
    isFavoritesModal,
    setIsFavoritesModal,
    handleShowChart,
    isChartLoading,
  } = useDomesticMarketMonthlyStockSalesContext();

  const handleSelectedFavorite = async (favorite) => {
    const { producer, producer_name } = favorite;

    await setSelectedCompany((prev) => ({
      ...prev,
      id: producer,
      name: producer_name,
    }));

    await handleShowChart({ company_id: producer });
    setIsFavoritesModal(false);
  };

  const handleDeleteFavorite = async (id, e) => {
    e.stopPropagation();
    const res = await deleteData(`/favorite/domestic-production/${id}`);
    if (res.status === 200) await mutate("/favorite/domestic-production");
  };

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{ color: "#212121", fontSize: "16px", fontWeight: 700 }}
        >
          مبلغ فروش ماهانه کالا
        </Typography>

        <ShowFavoritesButton onClick={() => setIsFavoritesModal(true)} />
      </Box>

      {/*MODAL*/}
      <Favorites
        isChartLoading={isChartLoading}
        isOpen={isFavoritesModal}
        handleClose={() => setIsFavoritesModal(false)}
        favorites={favorites}
        handleSelectedFavorite={handleSelectedFavorite}
        handleDeleteFavorite={handleDeleteFavorite}
        FavoriteCard={DomesticMarketMonthlyStockSalesFavoriteCard}
      />

      {/*FORM*/}
      <DomesticMarketMonthlyStockSalesForm />

      {/*CHART*/}
      <DomesticMarketMonthlyStockSalesChart />
    </Paper>
  );
};

export default DomesticMarketMonthlyStockSales;
